import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { ExcelOrderImport_DatasourceService } from './ExcelOrderImport.datasource.index';
import { TransloadOrders_DatasourceService } from './TransloadOrders.datasource.index';
import { PurchaseOrders_DatasourceService } from './PurchaseOrders.datasource.index';
import { FootprintApiManager_DatasourceService } from './FootprintApiManager.datasource.index';

import { app_custom_ds_account_contact_lookupService } from './app.datasource.index';
import { app_custom_ds_get_account_by_lookupcodeService } from './app.datasource.index';
import { app_custom_ds_get_carrier_id_by_nameService } from './app.datasource.index';
import { app_custom_ds_get_lots_for_order_importService } from './app.datasource.index';
import { app_custom_ds_get_order_class_id_by_nameService } from './app.datasource.index';
import { app_custom_ds_get_orders_by_lookupcodes_types_projects_warehousesService } from './app.datasource.index';
import { app_custom_ds_get_project_lookup_by_nameService } from './app.datasource.index';
import { app_custom_ds_get_transloadId_by_orderIdService } from './app.datasource.index';

@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.ExcelOrderImport = this.injector.get(ExcelOrderImport_DatasourceService);
    this.TransloadOrders = this.injector.get(TransloadOrders_DatasourceService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_DatasourceService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public ExcelOrderImport: ExcelOrderImport_DatasourceService;
    public TransloadOrders: TransloadOrders_DatasourceService;
    public PurchaseOrders: PurchaseOrders_DatasourceService;
    public FootprintApiManager: FootprintApiManager_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _custom_ds_account_contact_lookup: app_custom_ds_account_contact_lookupService;
  public get custom_ds_account_contact_lookup(): app_custom_ds_account_contact_lookupService {
    if(!this._custom_ds_account_contact_lookup) {
      this._custom_ds_account_contact_lookup = this.injector.get(app_custom_ds_account_contact_lookupService);
    }
    return this._custom_ds_account_contact_lookup;
  }
  private _custom_ds_get_account_by_lookupcode: app_custom_ds_get_account_by_lookupcodeService;
  public get custom_ds_get_account_by_lookupcode(): app_custom_ds_get_account_by_lookupcodeService {
    if(!this._custom_ds_get_account_by_lookupcode) {
      this._custom_ds_get_account_by_lookupcode = this.injector.get(app_custom_ds_get_account_by_lookupcodeService);
    }
    return this._custom_ds_get_account_by_lookupcode;
  }
  private _custom_ds_get_carrier_id_by_name: app_custom_ds_get_carrier_id_by_nameService;
  public get custom_ds_get_carrier_id_by_name(): app_custom_ds_get_carrier_id_by_nameService {
    if(!this._custom_ds_get_carrier_id_by_name) {
      this._custom_ds_get_carrier_id_by_name = this.injector.get(app_custom_ds_get_carrier_id_by_nameService);
    }
    return this._custom_ds_get_carrier_id_by_name;
  }
  private _custom_ds_get_lots_for_order_import: app_custom_ds_get_lots_for_order_importService;
  public get custom_ds_get_lots_for_order_import(): app_custom_ds_get_lots_for_order_importService {
    if(!this._custom_ds_get_lots_for_order_import) {
      this._custom_ds_get_lots_for_order_import = this.injector.get(app_custom_ds_get_lots_for_order_importService);
    }
    return this._custom_ds_get_lots_for_order_import;
  }
  private _custom_ds_get_order_class_id_by_name: app_custom_ds_get_order_class_id_by_nameService;
  public get custom_ds_get_order_class_id_by_name(): app_custom_ds_get_order_class_id_by_nameService {
    if(!this._custom_ds_get_order_class_id_by_name) {
      this._custom_ds_get_order_class_id_by_name = this.injector.get(app_custom_ds_get_order_class_id_by_nameService);
    }
    return this._custom_ds_get_order_class_id_by_name;
  }
  private _custom_ds_get_orders_by_lookupcodes_types_projects_warehouses: app_custom_ds_get_orders_by_lookupcodes_types_projects_warehousesService;
  public get custom_ds_get_orders_by_lookupcodes_types_projects_warehouses(): app_custom_ds_get_orders_by_lookupcodes_types_projects_warehousesService {
    if(!this._custom_ds_get_orders_by_lookupcodes_types_projects_warehouses) {
      this._custom_ds_get_orders_by_lookupcodes_types_projects_warehouses = this.injector.get(app_custom_ds_get_orders_by_lookupcodes_types_projects_warehousesService);
    }
    return this._custom_ds_get_orders_by_lookupcodes_types_projects_warehouses;
  }
  private _custom_ds_get_project_lookup_by_name: app_custom_ds_get_project_lookup_by_nameService;
  public get custom_ds_get_project_lookup_by_name(): app_custom_ds_get_project_lookup_by_nameService {
    if(!this._custom_ds_get_project_lookup_by_name) {
      this._custom_ds_get_project_lookup_by_name = this.injector.get(app_custom_ds_get_project_lookup_by_nameService);
    }
    return this._custom_ds_get_project_lookup_by_name;
  }
  private _custom_ds_get_transloadId_by_orderId: app_custom_ds_get_transloadId_by_orderIdService;
  public get custom_ds_get_transloadId_by_orderId(): app_custom_ds_get_transloadId_by_orderIdService {
    if(!this._custom_ds_get_transloadId_by_orderId) {
      this._custom_ds_get_transloadId_by_orderId = this.injector.get(app_custom_ds_get_transloadId_by_orderIdService);
    }
    return this._custom_ds_get_transloadId_by_orderId;
  }
}

